import React, { useState } from 'react';

import CEPField from '../fields/CEPField';
import { Box, Button, TextField } from '@material-ui/core';
import StateField from '../fields/StateField';
import CityField from '../fields/CityField';

const localDefaultAddress = {
  cep: '',
  street: '',
  district: '',
  uf: '',
  city: '',
  num: '',
  complement: ''
};

const validateForm = ({address}) => {
  const optionalFields = ['complement']
  const emptyFields = Object
    .entries(address)
    .filter(([field, value]) => !value && !optionalFields.includes(field))
    .map(([field]) => field);

  const errors = emptyFields.reduce((prev, field) => ({
    ...prev,
    [field]: 'Campo não pode ficar vazio'
  }), {});

  return {
    hasError: Object.values(errors).length > 0,
    errors
  }
}

export default function AddressForms({ defaultAddress, onAddressSubmit }) {
  const [address, setAddress] = useState(defaultAddress || localDefaultAddress);
  const [formError, setFormError] = useState(localDefaultAddress);

  const hasError = Object.values(formError).some(Boolean);

  const resetFormErrors = () => {
    if(hasError) {
      setFormError(localDefaultAddress);
    }
  }

  const handleChange = (e) => {
    e?.persist();
    resetFormErrors();

    setAddress(prev => ({...prev, [e.target.name]: e.target.value}));
  }

  const handleManualChange = (name, value) => {
    resetFormErrors();

    setAddress(prev => ({...prev, [name]: value}));
  }

  const handleCEPSuccess = (cepInfo) => {
    resetFormErrors();

    setAddress(prev => ({...prev, ...cepInfo}));
  }

  const handleSubmit = (e) => {
    e?.preventDefault();

    const validateError = validateForm({address});

    if(validateError.hasError) {
      setFormError(validateError.errors);
      return;
    }

    onAddressSubmit(address);
  }

  const handleCEPError = () => {
    setAddress(localDefaultAddress);
  }

  const allowNextStep = !hasError;

  return (
    <form onSubmit={handleSubmit}>
      <CEPField
        autoFocus
        defaultCEP={address.cep}
        onCEPSuccess={handleCEPSuccess}
        onCEPError={handleCEPError}
        error={formError?.cep}
        helperText={formError?.cep}
      />
      <TextField
        fullWidth
        label="Rua"
        name="street"
        value={address.street}
        onChange={handleChange}
        error={formError?.street}
        helperText={formError?.street}
      />
      <TextField
        fullWidth
        label="Bairro"
        name="district"
        value={address.district}
        onChange={handleChange}
        error={formError?.district}
        helperText={formError?.district}
      />
      <TextField
        fullWidth
        label="Número"
        name="num"
        value={address.num}
        onChange={handleChange}
        error={formError?.num}
        helperText={formError?.num}
      />
      {/* <TextField
        fullWidth
        label="Estado"
        name="uf"
        value={address.uf}
        onChange={handleChange}
      /> */}
      <StateField
        label="Estado"
        name="uf"
        state={address.uf}
        onChangeState={(state) => handleManualChange('uf', state)}
        error={formError?.uf}
        helperText={formError?.uf}
      />
      {/* <TextField
        fullWidth
        label="Cidade"
        name="city"
        value={address.city}
        onChange={handleChange}
      /> */}
      <CityField
        label="Cidade"
        name="city"
        stateUF={address.uf}
        city={address.city}
        onChangeCity={(city) => handleManualChange('city', city)}
        error={formError?.city}
        helperText={formError?.city}
      />
      <TextField
        fullWidth
        label="Complemento (Opcional)"
        name="complement"
        value={address.complement}
        onChange={handleChange}
        error={formError?.complement}
        helperText={formError?.complement}
      />
      <Box marginTop={3} justifyContent="flex-end" display="flex">
        <Button disabled={!allowNextStep} variant="contained" color="primary" type="submit">Salvar</Button>
      </Box>
    </form>
  )
}